import { gql } from '@apollo/client';

const downloadImages = gql`
  mutation downloadImages($images: [OrderGroupImageBankItemDownloadItem]) {
    initImageBankDownload(images: $images)
  }
`;

export default downloadImages;
